export default __webpack_public_path__ + "static/1789-b60f8eb163bf1da2f96335ffe2db20a6.gif";